module.exports = __webpack_public_path__ + "static/media/penwhite.ee384f17.svg";